const carouselData = [
  {
    title: '咒术回战最终章突入',
    desc: '芥见下下倾力打造的最终决战篇正式开启，宿傩与五条悟的究极对决震撼上演，每周更新不容错过。',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20dynamic%20manga%20battle%20scene%20with%20energy%20waves%20and%20dramatic%20composition%2C%20warm%20red%20and%20orange%20tones%20on%20dark%20background%2C%20Japanese%20comic%20art%20style%20with%20bold%20linework%20and%20speed%20lines%2C%20epic%20cinematic%20feel&width=800&height=500&seq=carousel-jjk-01&orientation=landscape',
  },
  {
    title: '海贼王最终章连载中',
    desc: '尾田荣一郎笔下的伟大航路迎来最终篇章，路飞与草帽团的冒险进入最高潮，免费漫画全集同步追更。',
    tag: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20illustration%20of%20adventure%20and%20ocean%20voyage%20theme%20with%20sailing%20ship%20silhouette%20and%20sunrise%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20Japanese%20manga%20inspired%20aesthetic%20with%20dramatic%20clouds%20and%20waves&width=800&height=500&seq=carousel-op-02&orientation=landscape',
  },
  {
    title: '间谍过家家剧场版预热',
    desc: '人气爆棚的福杰一家再次出动，剧场版上映在即，漫画最新更新同步放送，搞笑与温情并存。',
    tag: '剧场联动',
    image: 'https://readdy.ai/api/search-image?query=Whimsical%20artistic%20illustration%20of%20a%20stylish%20family%20silhouette%20in%20a%20retro%20European%20setting%2C%20warm%20amber%20and%20cream%20tones%2C%20playful%20spy%20theme%20with%20elegant%20composition%2C%20Japanese%20manga%20illustration%20style&width=800&height=500&seq=carousel-spy-03&orientation=landscape',
  },
  {
    title: '怪兽8号第二季制作决定',
    desc: '松本直也原作大热之作宣布第二季动画化，漫画原作持续高能更新中，科幻战斗盛宴等你来追。',
    tag: '动画化',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20artistic%20illustration%20of%20giant%20monster%20silhouette%20against%20cityscape%20at%20sunset%2C%20sci-fi%20manga%20aesthetic%20with%20orange%20and%20dark%20blue%20contrast%2C%20bold%20graphic%20composition%20with%20destruction%20and%20heroic%20scale&width=800&height=500&seq=carousel-k8-04&orientation=landscape',
  },
  {
    title: '胆大党动画热播中',
    desc: '龙幸伸的异色之作改编动画好评如潮，漫画原作同步追更中，灵异与科幻的奇妙碰撞持续上演。',
    tag: '动画热播',
    image: 'https://readdy.ai/api/search-image?query=Surreal%20artistic%20illustration%20with%20ghostly%20and%20sci-fi%20elements%20blending%20together%2C%20warm%20magenta%20and%20teal%20contrast%2C%20Japanese%20manga%20style%20composition%20with%20supernatural%20vibe%2C%20dreamy%20atmospheric%20lighting&width=800&height=500&seq=carousel-ddd-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            编辑部精选的连载漫画焦点内容，热门漫画更新速览
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {carouselData.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-transform cursor-pointer group"
            >
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-[11px] font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-800 mb-2 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}